import ClientParamModel, { ClientParamBackend } from 'App/resources/Model/ClientParam';
import { setClientParam } from 'Store/wrappedActions';
import Resource from 'Resources/ResourceTyped';

type Opts = {
	skipNotification?: boolean;
};
class ClientParam extends Resource<ClientParamModel> {
	constructor() {
		super('master/clientParam', null, { notificationTitle: 'admin.settings' });
	}

	map = ({ id, value }: ClientParamModel) => ({ paramId: id, value });
	parse = ({ paramId, value, name }: ClientParamBackend) => ({ id: paramId, value, name });

	async _afterSave(data: ClientParamModel, opts: Opts) {
		if (data.name) {
			setClientParam(data.name, data.value);
		}

		return super._afterSave(data, opts);
	}

	async _afterDelete(id: number, opts = {}) {
		return super._afterDelete(id, opts);
	}
}

const resource = new ClientParam();

export default resource;
